import type React from "react";

// Whether text is clipped depends on the container's current width, so it is measured at hover time.
// Pair with `noWrap` (or an equivalent ellipsis style) on the element it is attached to.
export function showTitleWhenClipped(text: string) {
  return (event: React.MouseEvent<HTMLElement>) => {
    const element = event.currentTarget;
    element.title = element.scrollWidth > element.clientWidth ? text : "";
  };
}
